import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';

import { testId } from 'ui-components/services/testid-service';
import { Checkbox } from 'ui-components/components/checkbox';

import { MarkAsShippedContext } from '../../../context';
import { MARK_AS_SHIPPED_NOTIFY_CUSTOMER } from '../../../constants';
import { stopPropagation } from '../../../helper';

import style from '../style.module.less';

const NotifyCustomer = ({ fulfillmentPlanId }) => {
  const {
    fulfillmentPlans: { [fulfillmentPlanId]: { notifyCustomer, disableNotifyCustomer } = {} },
    updateFulfillmentPlan,
  } = useContext(MarkAsShippedContext);

  const onClick = useCallback(() => {
    updateFulfillmentPlan(fulfillmentPlanId, MARK_AS_SHIPPED_NOTIFY_CUSTOMER, !notifyCustomer);
  }, [updateFulfillmentPlan, fulfillmentPlanId, notifyCustomer]);

  return (
    <div className={style.checkbox} {...testId('mark-as-shipped-notify-customer')} onClick={stopPropagation}>
      <Checkbox checked={!disableNotifyCustomer && notifyCustomer} disabled={disableNotifyCustomer} onChange={onClick} />
    </div>
  );
};

NotifyCustomer.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export default NotifyCustomer;
